// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"13c21049","133":"04859f33","182":"bd0e6f01","453":"a7db5265"}[chunkId] + ".chunk.js";
};